<template>
  <div>
    <dropup :button-text="$t('vue.deleteday.delete_day_or_week')"
            :show="showDropUp"
            @open="dropUp"
            @close="showDropUp = false">
      <template slot="list">
        <li v-for="weekdayNum in weekDaysLocale" :key="weekdayNum" @click="setIsConfirmDeletion(weekdayNum)">
          {{ formattedDate(weekdayNum) }}
        </li>
        <li @click="setIsConfirmDeletion('week')">{{ $t('vue.deleteday.whole_week') }}</li>
      </template>
    </dropup>
    <transition name="d-modal">
      <ModalConfirmation
        v-if="isConfirmDeletion"
        :showClose="false"
        @close="closeIsConfirmDelete"
        @confirm="confirmDelete">
        <h3 slot="item" style="padding: 1rem 1rem 0rem 1rem;">{{ theDeleteText }}</h3>
      </ModalConfirmation>
    </transition>
  </div>
</template>

<script>
import eventbus from '../eventbus'
import docendo from '../docendo'
import moment from 'moment'
import CustomEvent from '../polyfills/CustomEvent' // eslint-disable-line no-unused-vars
import dropup from './common/DropUp'
import ModalConfirmation from './Modals/ModalConfirmation'

export default {
  components: {dropup, ModalConfirmation},
  name: 'delete-day-or-week',
  props: {
    calendar: {},
    date: {
      default: null
    },
    internaldate: {
      type: Object,
      default () {
        return moment()
      }
    },
    currentdate: {
      type: String,
      default () {
        return ''
      }
    }
  },
  computed: {
    firstDayOfTheWeek () {
      return this.$store.getters.firstDayOfWeek
    },
    weekDaysLocale () {
      let arr = []
      // monday is 0++
      let start = this.firstDayOfTheWeek - 1
      for (let i = 0; i < 7; i++) {
        start++
        arr.push(start)
      }
      return arr.reverse()
    }
  },
  data () {
    return {
      showDropUp: false,
      isConfirmDeletion: false,
      _currentDate: this.currentdate,
      _internalDate: this.internaldate,
      isDeleteWeek: false,
      theDeleteText: '',
      theDeleteFromDate: moment(),
      theDeleteToDate: moment()
    }
  },
  methods: {
    setIsConfirmDeletion (day) {
      if (day === 'week') {
        this.theDeleteText = this.$t('vue2.common.delete') + ' ' + this.$t('vue.deleteday.whole_week')
        this.isDeleteWeek = true
      } else {
        this.theDeleteText = this.$t('vue2.common.delete') + ' ' + this.formattedDate(day)
        this.theDeleteFromDate = moment(this._internalDate).clone().day(day).startOf('day')
        this.theDeleteToDate = moment(this._internalDate).clone().day(day).endOf('day')
      }
      this.isConfirmDeletion = true
      this.showDropUp = false
    },
    closeIsConfirmDelete () {
      this.isConfirmDeletion = false
      this.isDeleteWeek = false
      this.theDeleteFromDate = moment(this._internalDate).clone().day(1).startOf('day')
      this.theDeleteToDate = moment(this._internalDate).clone().day(1).endOf('day')
    },
    confirmDelete () {
      if (this.isDeleteWeek) {
        this.deleteWeek()
      } else {
        this.deleteDay()
      }
      this.closeIsConfirmDelete()
    },
    dropUp () {
      this.showDropUp = true
      if (this.date) {
        this._internalDate = moment(this.date).format('YYYY-MM-DD')
      } else {
        // For ROR
        this._currentDate = document.querySelector('.calendar').getAttribute('data-current_date')
        this._internalDate = moment(this._currentDate, 'YYYY-MM-DD')
      }
    },
    formattedDate (day) {
      return this.internaldate.clone().day(day).format('dddd')
    },
    deleteDay () {
      const mFrom = moment(this.theDeleteFromDate).toDate()
      const mTo = moment(this.theDeleteToDate).toDate()
      if (moment(mFrom).isValid() && moment(mTo).isValid()) {
        docendo.deleteEventsRange(this.calendar, this.theDeleteFromDate.toISOString(), this.theDeleteToDate.toISOString(), this.deleted)
      } else {
        eventbus.toast = {text: this.$t('vue2.delete_day_or_week.cant_delete'), success: false}
      }
      this.showDropUp = false
    },
    deleteWeek () {
      let from = this.theDeleteFromDate = moment(this._internalDate).clone().day(this.weekDaysLocale[this.weekDaysLocale.length - 1])
      let to = this.theDeleteToDate = moment(this._internalDate).clone().day(this.weekDaysLocale[0]).endOf('day')
      docendo.deleteEventsRange(this.calendar, from.toISOString(), to.toISOString(), this.deleted)
      this.showDropUp = false
    },
    deleted () {
      this.$emit('update')
      // native event
      let event = new window.CustomEvent('UpdateCalendarEvents', {bubbles: true, cancelable: true})
      window.document.dispatchEvent(event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// DeleteDayOrWeek.vue?1e48d82e